var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleLine(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3 138",
    width: 3,
    height: 138,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Double Lines-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #040404 } \n\t\t.s2 { fill: #050505 } \n\t\t.s3 { fill: #121212 } \n\t\t.s4 { fill: #181818 } \n\t\t.s5 { fill: #101010 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-195 551.5c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-195 0c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer copy",
    className: "s0",
    d: "m-199 46c329.9 0 659.8 0 999.8 0q0 0.5 0 1c-330 0-659.9 0-999.8 0q0-0.5 0-1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m-194.8 321.7c329.8 0 659.6 0 999.3 0q0 0.5 0 1c-329.8 0-659.5 0-999.3 0q0-0.5 0-1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-194.8 413.6c329.7 0 659.4 0 999.1 0q0 0.5 0 1c-329.7 0-659.4 0-999.1 0q0-0.5 0-1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m-194.5 137.9c329.7 0 659.3 0 999 0q0 0.5 0 1c-329.7 0-659.3 0-999 0q0-0.5 0-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-194.8 46c329.7 0 659.4 0 999.1 0q0 0.5 0 1c-329.7 0-659.4 0-999.1 0q0-0.5 0-1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m-194.5 459.6c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m-194.5 275.8c329.6 0 659.2 0 998.8 0q0 0.4 0 0.9c-329.6 0-659.2 0-998.8 0q0-0.4 0-0.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m-194.5 183.8c329.6 0 659.2 0 998.8 0q0 0.5 0 1c-329.6 0-659.2 0-998.8 0q0-0.5 0-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleLine);
export default __webpack_public_path__ + "static/media/doubleLine.ae88a715f2127eb6fc736260eeca92f4.svg";
export { ForwardRef as ReactComponent };